import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@mui/material';
import Topbar from './Topbar';
import * as C from '../../theme/colors.constants';

/**
 * Casca de todas as telas.
 *
 * Estratégia de responsividade (requisito: base 1920x1200, crescendo acima):
 * - `maxWidth: 2560px` centralizado evita que em ultrawide o conteúdo fique
 *   esticado a ponto de perder legibilidade, mas ainda ocupa 100% até 2560.
 * - O padding lateral é `clamp()`, então cresce junto com a tela.
 * - Nenhuma largura de coluna é fixa em px: tudo é fr/%/flex, logo resoluções
 *   maiores apenas ganham espaço, sem reflow nem barra horizontal.
 */
export default function AppShell({ titulo, children, fullBleed = false }) {
  return (
    <Box sx={{ minHeight: '100vh', backgroundColor: C.pageBackground, pb: 8 }}>
      <Box sx={{ maxWidth: 2560, mx: 'auto', width: '100%' }}>
        <Topbar titulo={titulo} />
        <Box
          component="main"
          sx={{
            px: fullBleed ? 'clamp(12px, 1vw, 28px)' : 'clamp(12px, 1.25vw, 34px)',
            pt: 'clamp(8px, 0.6vw, 18px)',
          }}
        >
          {children}
        </Box>
      </Box>
    </Box>
  );
}
AppShell.propTypes = {
  titulo: PropTypes.string,
  children: PropTypes.node,
  fullBleed: PropTypes.bool,
};
